 <!--
 * @Author: amywulan
 * @Date: 2020-09-15 18:37:24
 * @LastEditors: amywulan
 * @LastEditTime: 2020-09-16 14:37:20
 * @Description: 获取优惠券
-->
<template>
  <div>
    <p class="title">{{gettext('获取优惠券')}}</p>
    <!-- 兑换优惠券 -->
    <add-coupons @exchangeSuccess="getResultInfo" @couponsShow="couponsShow"/>
    <!-- 购买优惠券 -->
    <transition name="fade">
      <coupons-item :itemData="payData" v-if="isInitPay">
        <buy-btn 
          slot="btn"
          :payData="payData"
          @getProductPay="getProductPay('pay')"
          @couponsShow="couponsShow"
        />
      </coupons-item>
    </transition>
    <!-- 邀请好友 -->
    <transition name="fade">
      <coupons-item :itemData="inviteData" v-if="isInit">
        <invite-btn 
          slot="btn"
          :inviteData="inviteData"
          @couponsShow="couponsShow"
        />
      </coupons-item>
    </transition>
     <!-- loading -->
    <loading-mask v-show="loading"></loading-mask>
  </div>
</template>

<script>
import LoadingMask from '@/components/loading/loading-mask'
import addCoupons from '../btnComponents/addCouponsBtn'
import { getProductListByCityId } from '@/api/newCouponsCenter/index'
import trackEvent from '@/common/js/track'
import couponsItem from './couponsItem'
import buyBtn from '../btnComponents/buyBtn'
import inviteBtn from '../btnComponents/inviteBtn'
import { getActivityType } from '@/common/js/utils'
import { mapActions } from 'vuex'
import { get } from 'lodash-es'
import { couponBuyCommonSw, cgcCardCommonSw } from '../../track'

export default {
  name: 'getCoupons',
  components: {
    couponsItem,
    buyBtn,
    inviteBtn,
    LoadingMask,
    addCoupons
  },
  data () {
    return {
      loading: false,
      isInitPay: false,
      isInit: false, // 初始化数据
      payData: {}, // 购买券包信息
      inviteData: {} // 邀请购买信息
    }
  },
  async mounted () {
    this.getProductPay()
    this.getGlobalInfo()
      .then((data) => this.fetchAcquisitionInfo(data))
      .catch(err => {
        const toast = this.$createToast({
          time: 3000,
          txt: err,
          type: 'error'
        })
        toast.show()
      })
  },
  methods: {
    ...mapActions({
      getGlobalInfo: 'getGlobalInfo',
      getAcquisitionInfo: 'getAcquisitionInfo'
    }),

    // 获取成功信息
    async getResultInfo () {
      this.$emit('getResultInfo')
    },
    couponsShow (val) {
      this.$emit('couponsShow', val)
    },
    // 券包详情
    async getProductPay (val) {
      try {
        this.isInitPay = false
        // 通过cityId获取券包信息
        const res = await getProductListByCityId()
        this.loading = false
        if (res && res.errno === 0) {
          if (get(res, 'data.productList').length > 0) {
            this.isInitPay = true
            // 权益活动为list格式，但是目前只会有一个活动。所以只取第一项
            const productInfo = get(res.data, 'productList[0]', {})
            this.payData = {
              type: 'pay',
              title: productInfo.valueDesc,
              des: productInfo.priceSplit && productInfo.priceSplit.display,
              productId: productInfo.productId,
              price: productInfo.price,
              canPurchase: productInfo.canPurchase,
              shopId: productInfo.shopId
            }
            // 券包购买卡片曝光
            couponBuyCommonSw()
          }
        }
      } catch (error) {}
      if (val === 'pay') {
        this.$emit('getResultInfo')
      }
    },
    // 邀请好友详情
    async fetchAcquisitionInfo (data) {
      this.loading = true
      this.isInit = false
      if (data.phone) {
        // 这里是进行上报用户登录成功
        trackEvent({
          eventId: 'tone_p_x_login_success',
          eventLabel: '用户登录成功',
          attrs: {
            phone: data.phone
          }
        })
      }
      this.activityType = getActivityType(data.businessType)
      let poiLat = data.poiLat || data.lat
      let poiLng = data.poiLng || data.lng
      try {
        const params = {
          token: data.token,
          activityType: this.activityType,
          poiLat: poiLat,
          poiLng: poiLng
        }
        let res = await this.getAcquisitionInfo(params)
        if (res && res.errno === 0 && res.data) {
          this.isInit = true
          this.$store.commit('UPDATE_ACQUISITIOIN_INFO', res.data)
          const inviteInfo = get(res.data, 'recommendPage.rewardInfo.amountSplit', {})
          this.inviteData = {
            type: 'invite',
            title: this.gettext('邀请一个好友即可获得'),
            des: inviteInfo.display,
            poiLat: poiLat,
            poiLng: poiLng,
            activityType: this.activityType
          }
          cgcCardCommonSw()
        } else { }
        this.loading = false
      } catch (e) {
        this.isInit = true
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.fade-enter{
  opacity: 0;
}
.fade-enter-active{
  transition: opacity 1.2s ease;
}
.title{
  font-family: 'Aspira Medium';
  font-size: 48px;
  color: #FFFFFF;
  margin:88px 0 32px;
}
.mask{
  left: 50%;
  top: 50%;
  background-color: #ffffff;
  transform: translate(-50%, -100%);
  width: 60px;
  height: 32px;
  border-radius: 8px;
  padding: 18px 40px 38px 40px;
  box-shadow: 0 16px 80px rgba(0,0,0,.16);
}
</style>